<template>
    <master-layout>
        <div class="error_page t_center">
            <div class="relative">
            	<svg id="_02-ghost" data-name="02-ghost" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 428.59 578.3">
                	<g id="ghost">
    					<path class="ghost-1" d="M525.8,359.1c-14.13-49.54-5.28-101-19.23-150.5-17.89-63.48-71.35-100.45-136.9-100.32C275.42,108.45,209.31,210,214.14,297c2.07,37.22-1.26,74.93-7.23,111.67-6.13,37.67-11.24,113.73,35.23,132.32,20,8,54,2,56-14,0,0,16,48,44,48s42-8,50-26c0,0,18,32,42,26s32-38,32-38,12,18,44,8,26-46,26-46,4,10,26,8c40.34-3.67,31.08-52.35,9.79-70.89C548.35,415.57,534.19,388.52,525.8,359.1Z" transform="translate(-202.99 -108.27)"/>
    					<ellipse class="ghost-2" cx="301.19" cy="204.79" rx="27.5" ry="13.46" transform="translate(-214.88 282.63) rotate(-64.94)"/>
    					<ellipse class="ghost-2" cx="366.84" cy="199.5" rx="18.98" ry="28.99" transform="translate(-248.24 23.77) rotate(-19.24)"/>
    					<path class="ghost-2" d="M313.51,247.06s37.69-8.57,45.9,17.53,5.88,52.54-13.29,46.82-19.27-42.63-19.27-42.63,2.67-15.55-13.06-12.95S308.23,247.9,313.51,247.06Z" transform="translate(-202.99 -108.27)"/>
    				</g>
                </svg>
                <div class="ghost_shadow"></div>
            </div>
            <h1 class="bold">500</h1>
            <h2>{{ $t('_error_pages.500_title') }}</h2>
            <h4 class="text-muted m-b-50">{{ $t('_error_pages.500_desc') }}</h4>
            <router-link :to="{ name: 'dashboard.index' }" class="btn btn-primary m-b-10">
                <span class="btn-label">
                    <i class="ti-pie-chart"></i>
                </span>
                {{ $t('dashboard') }}
            </router-link>
            <router-link :to="{ name: 'deals.index' }" class="btn btn-inverse m-b-10">
                <span class="btn-label">
                    <i class="icon-directions"></i>
                </span>
                {{ $t('deals') }}
            </router-link>
        </div>
    </master-layout>
</template>

<script>
    export default {
        name: 'InternalServerError'
    }
</script>



// WEBPACK FOOTER //
// src/modules/errors/components/500.vue